import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';


const Activation: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.from !== '/register') {
            navigate('/'); // Redirect to register page if not coming from register
        }
    }, [location.state, navigate]);

    return (
        <>
            <div>
                <h1 style={{ textAlign: "center", paddingTop: "40px" }}>Account-Aktivierung</h1>

                <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "20px" }}>
                    Bitte überprüfen Sie Ihr E-Mail-Postfach und klicken Sie auf den Aktivierungslink, um Ihren Account zu aktivieren.
                </p>
            </div>

        </>
    );
}

export default Activation;
